module.exports = __webpack_public_path__ + "static/media/close.ea657180.svg";